export const pt = {
  // Navigation
  nav: {
    home: "Início",
    transactions: "Lançamentos",
    charts: "Gráficos",
    goals: "Metas",
    budgets: "Orçamentos",
    reports: "Relatórios",
    family: "Família",
    admin: "Admin",
    darkMode: "Modo escuro",
    lightMode: "Modo claro",
    settings: "Configurações",
    whatsapp: "WhatsApp",
    bills: "Contas",
    adminPanel: "Painel Admin",
    logout: "Sair",
  },

  // Dashboard
  dashboard: {
    title: "Painel Financeiro",
    monthBalance: "SALDO DO MÊS",
    income: "RECEITAS",
    expenses: "DESPESAS",
    savingsRate: "TAXA POUPANÇA",
    recentTransactions: "Lançamentos Recentes",
    noTransactions: "Nenhum lançamento este mês",
    addFirst: "Adicione seu primeiro lançamento",
    incomeVsExpenses: "Receitas vs Despesas",
    expensesByCategory: "Gastos por Categoria",
    balanceEvolution: "Evolução do Saldo",
    noExpenses: "Nenhum gasto registrado neste mês",
    welcome: "Bem-vindo ao Bolso!",
    welcomeNew: "Novo",
    welcomeDesc: "Registre seus gastos em segundos — pelo site, por voz ou direto no WhatsApp.",
    byApp: "Pelo site",
    byAppDesc: "Toque em + para adicionar um lançamento",
    byVoice: "Por voz",
    byVoiceDesc: 'Fale "gasolina 150 reais" e pronto',
    byWhatsApp: "Via WhatsApp",
    byWhatsAppDesc: "Envie mensagem ou áudio sem abrir o site",
    linkWhatsApp: "Vincular WhatsApp",
    alreadyKnow: "Já sei usar, fechar",
    inviteTitle: "Convide alguém para testar",
    inviteDescription: "Compartilhe o Bolso pelo WhatsApp. O acesso é gratuito durante o período de teste.",
    inviteButton: "Compartilhar pelo WhatsApp",
    trialDays: "{days} dias restantes no teste gratuito",
    trialToday: "Último dia do teste gratuito",
    trialEnded: "Período de teste gratuito encerrado",
  },

  // Transactions
  transactions: {
    title: "Lançamentos",
    new: "Novo Lançamento",
    edit: "Editar Lançamento",
    delete: "Excluir",
    confirmDelete: "Excluir lançamento?",
    confirmDeleteDesc: "Esta ação não pode ser desfeita.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    type: "Tipo",
    income: "Receita",
    expense: "Despesa",
    transfer: "Transferência",
    amount: "Valor",
    description: "Descrição",
    category: "Categoria",
    date: "Data",
    notes: "Observações",
    save: "Salvar",
    noTransactions: "Nenhum lançamento encontrado",
    search: "Buscar lançamentos...",
    filter: "Filtrar",
    all: "Todos",
    receipt: "Comprovante",
    aiCategorized: "Categorizado por IA",
    addTransaction: "Adicionar lançamento",
  },

  // Goals
  goals: {
    title: "Metas",
    new: "Nova Meta",
    edit: "Editar Meta",
    delete: "Excluir Meta",
    name: "Nome",
    targetAmount: "Valor Alvo",
    currentAmount: "Valor Atual",
    deadline: "Prazo",
    icon: "Ícone",
    color: "Cor",
    linkedCategory: "Categoria vinculada (opcional)",
    progress: "Progresso",
    completed: "Concluída",
    active: "Ativa",
    cancelled: "Cancelada",
    noGoals: "Nenhuma meta criada",
    createFirst: "Crie sua primeira meta financeira",
    save: "Salvar",
    cancel: "Cancelar",
    of: "de",
    daysLeft: "dias restantes",
    overdue: "Prazo vencido",
    noDeadline: "Sem prazo definido",
  },

  // Budgets
  budgets: {
    title: "Orçamentos",
    new: "Novo Orçamento",
    edit: "Editar Orçamento",
    delete: "Excluir",
    category: "Categoria",
    limit: "Limite",
    spent: "Gasto",
    remaining: "Restante",
    month: "Mês",
    year: "Ano",
    noBudgets: "Nenhum orçamento definido",
    createFirst: "Defina limites de gastos por categoria",
    save: "Salvar",
    cancel: "Cancelar",
    of: "de",
    alert80: "80% do limite atingido",
    alert100: "Limite atingido!",
    used: "utilizado",
  },

  // Reports
  reports: {
    title: "Relatórios",
    period: "Período",
    monthly: "Mensal",
    annual: "Anual",
    byCategory: "Por Categoria",
    family: "Familiar",
    individual: "Individual",
    export: "Exportar",
    income: "Receitas",
    expenses: "Despesas",
    balance: "Saldo",
    noData: "Nenhum dado para o período selecionado",
  },

  // Family
  family: {
    title: "Família",
    create: "Criar Grupo Familiar",
    join: "Entrar em um Grupo",
    inviteCode: "Código de Convite",
    members: "Membros",
    admin: "Admin",
    member: "Membro",
    leave: "Sair do Grupo",
    noFamily: "Você não faz parte de nenhum grupo familiar",
    createOrJoin: "Crie ou entre em um grupo para compartilhar finanças",
    name: "Nome do Grupo",
    save: "Salvar",
    cancel: "Cancelar",
    copyCode: "Copiar Código",
    codeCopied: "Código copiado!",
  },

  // Settings / Profile
  settings: {
    title: "Configurações",
    profile: "Perfil",
    preferences: "Preferências",
    currency: "Moeda",
    language: "Idioma",
    save: "Salvar",
    saved: "Salvo!",
    cancel: "Cancelar",
    currencies: {
      BRL: "Real Brasileiro (R$)",
      EUR: "Euro (€)",
      USD: "Dólar Americano ($)",
      GBP: "Libra Esterlina (£)",
    },
    languages: {
      pt: "Português",
      en: "English",
      es: "Español",
      it: "Italiano",
    },
    categories: {
      title: "Minhas categorias",
      description: "Crie categorias próprias para organizar suas despesas e receitas.",
      expense: "Despesas",
      income: "Receitas",
      namePlaceholder: "Nome da categoria",
      add: "Adicionar categoria",
      edit: "Editar categoria",
      save: "Salvar categoria",
      cancel: "Cancelar",
      delete: "Excluir categoria",
      empty: "Nenhuma categoria personalizada",
      deleteConfirm: "Excluir esta categoria? Os lançamentos existentes serão mantidos.",
      parent: "Categoria principal",
      noParent: "Sem categoria principal",
      subcategory: "Subcategoria",
      created: "Categoria criada!",
      updated: "Categoria atualizada!",
      deleted: "Categoria excluída!",
    },
  },

  // Auth
  auth: {
    login: "Entrar",
    register: "Cadastrar",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    confirmPassword: "Confirmar Senha",
    forgotPassword: "Esqueci minha senha",
    loginWithManus: "Entrar com Manus",
    loginWithGoogle: "Entrar com Google",
    noAccount: "Não tem conta?",
    hasAccount: "Já tem conta?",
    verifyEmail: "Verifique seu e-mail",
    verifyEmailDesc: "Enviamos um link de confirmação para",
    resendEmail: "Reenviar e-mail",
    resetPassword: "Redefinir Senha",
    newPassword: "Nova Senha",
    resetSuccess: "Senha redefinida com sucesso!",
    logout: "Sair",
  },

  // WhatsApp
  whatsapp: {
    title: "Configurações do WhatsApp",
    linked: "WhatsApp vinculado",
    notLinked: "WhatsApp não vinculado",
    link: "Vincular WhatsApp",
    unlink: "Desvincular",
    phone: "Número de telefone",
    verifyCode: "Código de verificação",
    step1: "Salve o número do Bolso",
    step2: 'Envie a mensagem "join ago-family"',
    step3: "Gere seu código de vinculação",
    step4: "Envie o código pelo WhatsApp",
    generate: "Gerar Código",
    copy: "Copiar",
    copied: "Copiado!",
    commands: "Comandos disponíveis",
    cmdBalance: '"saldo" — ver saldo do mês',
    cmdSummary: '"resumo" — resumo dos gastos',
    cmdHelp: '"ajuda" — ver todos os comandos',
  },

  // Common
  common: {
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    add: "Adicionar",
    close: "Fechar",
    back: "Voltar",
    next: "Próximo",
    confirm: "Confirmar",
    search: "Buscar",
    filter: "Filtrar",
    noData: "Nenhum dado",
    tryAgain: "Tentar novamente",
    comingSoon: "Em breve",
    january: "Janeiro",
    february: "Fevereiro",
    march: "Março",
    april: "Abril",
    may: "Maio",
    june: "Junho",
    july: "Julho",
    august: "Agosto",
    september: "Setembro",
    october: "Outubro",
    november: "Novembro",
    december: "Dezembro",
    months: ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],
  },

  // Voice
  voice: {
    title: "Entrada por Voz",
    hold: "Segure para gravar",
    release: "Solte para processar",
    processing: "Processando...",
    confirm: "Confirmar lançamento",
    retry: "Tentar novamente",
    error: "Não foi possível processar o áudio",
    noMic: "Microfone não disponível",
    speakTransaction: "Fale seu lançamento",
    idleHint: 'Diga algo como "gastei 50 reais no mercado"',
    recordingHint: "Gravando... toque para parar",
    manualEntry: "Registrar manualmente",
    startRecording: "Iniciar gravação",
    stopRecording: "Parar gravação",
    microphoneDenied: "Permissão de microfone negada. Verifique as configurações do navegador.",
    unsupportedBrowser: "Este navegador não oferece um formato de áudio compatível. Registre manualmente.",
    exampleExpense: '"Gastei 45 reais no supermercado"',
    exampleIncome: '"Recebi 3500 de salário"',
    exampleFuel: '"Paguei 80 de gasolina"',
  },

  // Bills
  bills: {
    title: "Contas",
    payable: "A Pagar",
    receivable: "A Receber",
    all: "Todas",
    pending: "Pendentes",
    paid: "Pagas",
    new: "Nova Conta",
    edit: "Editar Conta",
    delete: "Excluir",
    markPaid: "Marcar como paga",
    markUnpaid: "Desfazer pagamento",
    dueDate: "Vencimento",
    amount: "Valor",
    type: "Tipo",
    recurrence: "Recorrência",
    recurrenceNone: "Sem recorrência",
    recurrenceWeekly: "Semanal",
    recurrenceMonthly: "Mensal",
    recurrenceYearly: "Anual",
    notes: "Observações",
    category: "Categoria",
    noBills: "Nenhuma conta cadastrada",
    addFirst: "Adicione sua primeira conta a pagar ou receber",
    dueSoon: "Contas próximas",
    overdue: "Vencida",
    dueToday: "Vence hoje",
    dueTomorrow: "Vence amanhã",
    confirmDelete: "Excluir conta?",
    confirmDeleteDesc: "Esta ação não pode ser desfeita.",
    titleLabel: "Título",
    titlePlaceholder: "Ex: Aluguel, Conta de luz...",
    save: "Salvar",
    cancel: "Cancelar",
  },

  // Admin
  admin: {
    title: "Painel de Administração",
    subtitle: "Visão geral dos usuários e configurações do beta",
    totalUsers: "Total de usuários",
    activeUsers: "Ativos (7 dias)",
    inactiveUsers: "Inativos",
    totalTransactions: "Total de lançamentos",
    betaExpiry: "Encerramento do período de testes",
    noExpiry: "Nenhuma data de encerramento definida.",
    setExpiry: "Definir data de encerramento",
    saveDate: "Salvar data",
    registeredUsers: "Usuários Cadastrados",
    inviteAccess: "Acesso por convite",
    inviteMode: "Modo restrito",
    inviteModeDesc: "Quando ativo, apenas e-mails autorizados podem criar conta.",
    enableRestrict: "Restringir acesso",
    disableRestrict: "Abrir acesso",
    authorizedEmails: "E-mails autorizados",
    addEmail: "Adicionar e-mail",
    removeEmail: "Remover",
    copyEmails: "Copiar todos",
    maxSlots: "Limite de vagas",
    slotsUsed: "vagas usadas",
    back: "← Voltar",
  },
};

export type Translations = typeof pt;
